import { MARKET_TODAY, MARKET_TODAY_ERROR, MARKET_TODAY_HIDE_ERROR, MARKET_TODAY_START_LOADER, MARKET_TODAY_STOP_LOADER, MARKET_TODAY_STREAMING, } from "../interface/iMarketToday";
import { marketTodayStream, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
const initialState = {
    data: {
        marketsToday: [],
    },
    marketTodayLoader: true,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const marketToday = (state = initialState, action) => {
    switch (action.type) {
        case MARKET_TODAY:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case MARKET_TODAY_STREAMING:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { marketsToday: marketTodayStream(state.data.marketsToday, action.payload.qouteStream) }) });
        case MARKET_TODAY_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MARKET_TODAY_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case MARKET_TODAY_START_LOADER:
            return Object.assign(Object.assign({}, state), { marketTodayLoader: true });
        case MARKET_TODAY_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { marketTodayLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default marketToday;
